module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_11.a9ea2ec0.mp3";